module.exports = __webpack_public_path__ + "img/screen-capture.3291af88.png";